module.exports = __webpack_public_path__ + "static/livesync_mosaic_lobby-3e396ed5d6d7902c1470d05801bafb96.png";